import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStateTaxDetailTable extends Layout {
    sourceStatetaxdetail: DataSource;
    tableStateTaxDetail: Table;
}
